import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const Register = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRegister = async () => {
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (reg.test(email) === false) {
      alert("Please Enter Correct Email id");
      return false;
    }

    if (name.trim() === '') {
      alert("Please Enter Your Name");
      return false;
    }

    if (mobile.trim() === '' || mobile.length < 10) {
      alert("Please Enter Valid Mobile Number");
      return false;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('name', name);
      formData.append('mobile', mobile);

      const response = await fetch('https://octafxx.in/Rest/web_register_api0', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      });

      const result = await response.json();
      console.log(result);
      
      if (result.status == 0) {
        alert('OTP sent successfully.');
        // Navigate without page refresh, passing data in state
        navigate('/password', { 
          state: { 
            email: email, 
            name: name, 
            mobile: mobile 
          } 
        });
      } else {
        alert(result.msg || 'Registration failed.');
      }
    } catch (error) {
      console.error('Registration error:', error);
      alert('Failed to connect to the server. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#F8F9FA' }}>
      {loading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="bg-white p-4 rounded-3 text-center shadow-lg">
            <Spinner animation="border" variant="primary" />
            <div className="mt-2">Creating account...</div>
          </div>
        </div>
      )}

      <div className="container" style={{ maxWidth: '450px', padding: '20px' }}>
        <div className="text-center mb-4">
          <h1 className="fw-bold" style={{ color: '#1A1A1A' }}>Create Account</h1>
          <p className="text-secondary">Enter your details to get started</p>
        </div>

        {/* Name Input */}
        <div className="mb-3">
          <div className="bg-white rounded-4 p-2" style={{ border: '1px solid #E8E8E8' }}>
            <label className="form-label mb-0 px-2 pt-2 fw-semibold small text-uppercase" style={{ color: '#0054bd' }}>
              FULL NAME
            </label>
            <div className="d-flex align-items-center px-2 pb-2">
              <i className="bi bi-person me-3" style={{ fontSize: 20, color: '#0054bd' }}></i>
              <input
                type="text"
                className="form-control border-0 ps-0"
                placeholder="John Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Email Input */}
        <div className="mb-3">
          <div className="bg-white rounded-4 p-2" style={{ border: '1px solid #E8E8E8' }}>
            <label className="form-label mb-0 px-2 pt-2 fw-semibold small text-uppercase" style={{ color: '#0054bd' }}>
              EMAIL ADDRESS
            </label>
            <div className="d-flex align-items-center px-2 pb-2">
              <i className="bi bi-envelope me-3" style={{ fontSize: 20, color: '#0054bd' }}></i>
              <input
                type="email"
                className="form-control border-0 ps-0"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Mobile Input */}
        <div className="mb-4">
          <div className="bg-white rounded-4 p-2" style={{ border: '1px solid #E8E8E8' }}>
            <label className="form-label mb-0 px-2 pt-2 fw-semibold small text-uppercase" style={{ color: '#0054bd' }}>
              PHONE NUMBER
            </label>
            <div className="d-flex align-items-center px-2 pb-2">
              <i className="bi bi-phone me-3" style={{ fontSize: 20, color: '#0054bd' }}></i>
              <input
                type="tel"
                className="form-control border-0 ps-0"
                placeholder="9876543210"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                maxLength={10}
              />
            </div>
          </div>
        </div>

        {/* Register Button */}
        <button
          className="btn w-100 py-3 fw-bold"
          style={{
            backgroundColor: '#0054bd',
            color: '#FFFFFF',
            borderRadius: 16,
            boxShadow: '0 4px 14px rgba(0,84,189,0.25)'
          }}
          onClick={handleRegister}
          disabled={loading}
        >
          {loading ? <Spinner animation="border" size="sm" /> : 'CONTINUE'}
        </button>

        {/* Footer */}
        <div className="text-center mt-4">
          <span className="text-secondary">Already have an account? </span>
          <button
            className="btn btn-link p-0 text-decoration-none fw-semibold"
            style={{ color: '#0054bd' }}
            onClick={() => navigate('/login')}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;